import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { UserManagementService } from '../../services/user-management.service';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { AppSettings } from 'app/modules/shared/app.settings';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { PasswordModule } from 'primeng/password';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { CommonModule, Location } from '@angular/common';
import { EncryptionService } from 'app/shared/services/encryption.service';
import { ResetPasswordData, UserDetailsResponse, ResetPasswordResponse, ApiErrorResponse } from '../../models/user-management';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss',
  standalone: true,
  imports: [BreadcrumbModule, ButtonModule, TranslateModule, FormsModule, ReactiveFormsModule, InputTextModule, DialogModule, KeyFilterModule, PasswordModule, AccessProviderDirective, CommonModule],
})
export class UserDetailsComponent implements OnInit {
  routePath: MenuItem[] = [];
  userId: string;
  userDetails: UserDetailsResponse;
  roleName: string;
  editBtnLabel: string;
  visible: boolean = false;
  addNewPassword: string;
  blockChars = AppSettings.BLOCK_CHARS;
  eventNames: string;
  defaultPasswordForm: FormGroup;
  attributeValues: Record<string, unknown>;
  minLength = 8;
  maxLength = 20;
  passwordMinLengthValidator = AppSettings.PASSWORD_PATTERN;
  requireAtLeastOne: string[];
  allowedCharacterValidator: RegExp;
  passwordRequirementsMessage: string;
  newPasswordErrorMessage: string;
  submitted = false;
  cameFromManageUsers = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userManagementService: UserManagementService,
    private cs: CommonBindingDataService,
    private configService: ConfigService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private entityService: EntityService,
    private encryptionService: EncryptionService,
    private location: Location,
  ) {

  }

  ngOnInit(): void {
    this.editBtnLabel = this.cs.getLabel('lbl_edit');
    this.route.queryParams.subscribe(params => {
      this.userId = params.id;
      if (this.userId) {
        this.getUserDetailsDetails();
      }
    })
    const prevUrl = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
    this.cameFromManageUsers = !!prevUrl && prevUrl.includes('/app/manage-users');
    this.setRoutePath();
    this.resetPasswordFlow();
  }

  resetPasswordFlow() {
    this.getSecuritySettings();
    this.defaultPasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(AppSettings.PASSWORD_PATTERN_NO_WS)]],
    });
  }

  getSecuritySettings() {
    // this.entityService.getEntityDetailsByView(AppSettings.ENTITY_TYPE.SECURITY_SETTINGS, {}).subscribe({
    //   next: (response: any) => {
    //     const entityId = response.entityId;
    //     this.getEntityDetails(entityId);
    //   },
    //   error: () => {
    //   }
    // })
  }

  getEntityDetails() {
    // this.entityService.getEntity(entityId, AppSettings.ENTITY_TYPE.SECURITY_SETTINGS, AppSettings.VIEW_CODE.ADD_EDIT_VIEW).subscribe({
    //   next: (response: any) => {
    //     this.attributeValues = this.cs.getOrgAttributeValues(response);
    //     this.minLength = this.attributeValues['min_length'];
    //     const requireAtLeastOne = this.attributeValues['require_at_least_one'];
    //     const passwordRequirements = [];
    //     if (requireAtLeastOne) {
    //       if (requireAtLeastOne.includes('Uppercase and Lower case letter')) {
    //         passwordRequirements.push(this.cs.getLabel('lbl_must_contain_uppercase_lowercase'));
    //       }
    //       if (requireAtLeastOne.includes('Numeric character (0-9)')) {
    //         passwordRequirements.push(this.cs.getLabel('lbl_must_contain_digits'));
    //       }
    //       if (requireAtLeastOne.includes('Special character (!, @, #, etc.)')) {
    //         passwordRequirements.push(this.cs.getLabel('lbl_must_contain_special_character'));
    //       }
    //     }
    //     this.passwordRequirementsMessage = passwordRequirements.join(', ');
    //     let baseConditions = '';
    //     let allowedCharacters = '';

    //     if (requireAtLeastOne.includes('Uppercase and Lower case letter')) {
    //       baseConditions += '(?=.*[A-Z])(?=.*[a-z])';
    //       allowedCharacters += 'A-Za-z';
    //     }

    //     if (requireAtLeastOne.includes('Numeric character (0-9)')) {
    //       baseConditions += '(?=.*\\d)';
    //       allowedCharacters += '0-9';
    //     }

    //     if (requireAtLeastOne.includes('Special character (!, @, #, etc.)')) {
    //       baseConditions += '(?=.*[!@#$%^&*()_+\\-=[\\]{};:"\\,.<>/?|`~])';
    //       allowedCharacters += '!@#$%^&*()_+\\-=[\\]{};:"\\,.<>/?|`~';
    //     }

    //     const lengthCondition = `.{${this.minLength},}$`;
    //     const allowedCharacterPattern = `^[${allowedCharacters}]*$`;
    //     const updatedPattern = baseConditions + lengthCondition;
    //     this.passwordMinLengthValidator = new RegExp(updatedPattern);
    //     this.allowedCharacterValidator = new RegExp(allowedCharacterPattern);
    //     this.defaultPasswordForm.controls['newPassword'].setValidators([ Validators.required, Validators.pattern(this.passwordMinLengthValidator), Validators.pattern(this.allowedCharacterValidator)]);
    //     this.defaultPasswordForm.controls['newPassword'].updateValueAndValidity();
    //     this.setPasswordErrorMessages();
    //   },
    //   error: (error) => {
    //     this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel(error.errors.general[0].message) });
    //   }
    // });
  }

  setPasswordErrorMessages() {
    const newPasswordControl = this.defaultPasswordForm?.controls;
    if (newPasswordControl?.newPassword?.errors) {
      if (newPasswordControl?.newPassword?.errors?.required) {
        this.newPasswordErrorMessage = this.cs.getLabel('lbl_password_required');
      } else if (newPasswordControl?.newPassword?.errors?.pattern) {
        this.newPasswordErrorMessage = this.cs.getLabel('settings.password_pattern');
      }
    }
  }

  setRoutePath() {
    this.routePath = [
      {
        label: this.cs.getLabel('manage_users.lbl_route_users'),
        command: () => this.handleBack(),
        icon: 'pi pi-arrow-left',
        iconStyle: { 'font-weight': '600', 'margin-right': '10px' }
      },
      {
        label: this.cs.getLabel('manage_users.lbl_route_user_details'),
        styleClass: 'breadcrumb-child forward-slash add-text',
        style: { 'display': 'flex', 'top': '2px', 'position': 'relative' }
      }
    ];
  }

  getUserDetailsDetails() {
    this.userManagementService.getUserDetails(this.userId).subscribe((userData: UserDetailsResponse) => {
      this.userDetails = userData;
      if (userData.rolelist && userData.rolelist.length > 0) {
        this.roleName = userData.rolelist[0].roleName;
      }
      if (userData.eventList && userData.eventList.length > 0) {
        this.eventNames = userData.eventList.map(event => event.eventName).join(', ');
      }
    });
  }

  handleBack() {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }
    this.router.navigate(['app/manage-users']);
  }

  onShowDialog() {
    this.resetPasswordFlow();
    this.visible = true;
  }

  onHide() {
    this.submitted = false;
    this.defaultPasswordForm.reset(undefined, { emitEvent: false });
    this.visible = false;
  }

  onResetPassword() {
    this.submitted = true;
    if (this.defaultPasswordForm.valid) {
      try {
        // Encrypt the new password before sending to API
        const encryptedNewPassword = this.encryptionService.encryptPassword(this.defaultPasswordForm.controls.newPassword.value);

        const data: ResetPasswordData = {
          forTenantCode: this.configService.getForTenantCode(),
          newPassword: encryptedNewPassword
        }
        this.userManagementService.resetPassword(this.userId, data).subscribe({
          next: (res: ResetPasswordResponse) => {
            this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel(res.message) });
            this.visible = false;
          },
          error: (error: ApiErrorResponse) => {
            this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel(error.errors.general[0].message) });
            this.visible = false;
          }
        })
      } catch (error) {
        this.messageService.add({
          key: 'tst',
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to process password reset. Please try again.'
        });
      }
    }
  }

  edit() {
    this.route.queryParams.subscribe(queryParam => {
      this.router.navigate(['app/manage-users/edit-user/'], { queryParams: { id: queryParam.id } });
    })
  }

}
